export class ButtplugEmbeddedConnectorOptions {
    constructor() {
        this.ServerName = "Buttplug WASM Embedded Server";
        // Empty string means ignore.
        this.DeviceConfigJSON = "";
        // Empty string means ignore.
        this.UserDeviceConfigJSON = "";
        // 0 here means all device.
        this.DeviceCommunicationManagerTypes = 0;
        // Require opt-in on raw messages.
        this.AllowRawMessages = false;
        this.MaxPingTime = 0;
    }
}
export class ButtplugWebsocketConnectorOptions {
    constructor() {
        // Default to the insecure port.
        this.Address = "ws://127.0.0.1:12345";
    }
}
//# sourceMappingURL=connectors.js.map